import styled from 'styled-components';

export const Quote = styled.div`
  border-left: solid 4px ${props => props.theme.colorGrey};
  padding: 10px 0px 10px 20px;
  font-family: ${props => props.theme.fontFamilyTitle};
  color: ${props => props.theme.colorGreyDark};
  font-size: ${props => props.theme.fontSizeM};
  line-height: ${props => props.theme.fontLineHeightM};
  font-style: italic;

  @media (${props => props.theme.underScreenSmall}) {
    font-size: ${props => props.theme.fontSizeS};
    line-height: ${props => props.theme.fontLineHeightS};
  }
`;
